import React, { useState, useEffect } from 'react';
import {
    TableHead,
    TableBody,
    TablePagination,
    TextField,
    Grid,
    Container, MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledTableHeadRow,
    StyledTable, StyledTableBodyRow, StyledTableCellHeader
} from "../../../styles/MyStyles";
import {GetLookupValueName, UpsertLookup} from "../../../logic/LookupHelper";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";

const OwnWalletsPage = () => {
    const [clients, setClients] = useState([]);
    const [wallets, setWallets] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const [selectedClient, setSelectedClient] = useState('');

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        const fetchWallets = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(
                    `${process.env.REACT_APP_WALLETS_URL}/${process.env.REACT_APP_NEWCENT_CONTACT_ID}`,
                    {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setWallets(data.data);
                    if (data.data) {
                        UpsertLookup('ownWallets', data.data);
                    }
                } else {
                    console.log('Fetch Own Wallets failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        fetchWallets();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const editWallet = (walletId) => {
        navigate(`edit/${walletId}`);
    };

    const createWallet = () => {
        navigate(`edit/`);
    };

    const getClientsMenuItems = () => {
        let items = [<MenuItem key="" value="">All</MenuItem>];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    // Filter the clients based on the search query
    const filteredWallets = wallets ? wallets.filter(
        (wallet) =>
            wallet.address.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (selectedClient === '' || wallet.forClientId === parseInt(selectedClient))
    ) : [];

    const handleClientFilter = (event) => {
        setSelectedClient(event.target.value);
    };

    // Calculate pagination values
    const totalEntities = filteredWallets.length;
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedEntities = filteredWallets.slice(startIndex, endIndex);

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Client"
                        value={selectedClient}
                        onChange={handleClientFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {getClientsMenuItems()}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={createWallet} margin="normal">
                            New
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={5}>Asset</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Owner</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>For Client</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Address</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Multisig</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {paginatedEntities && paginatedEntities.map((wallet) => (
                                <StyledTableBodyRow key={wallet.id} onClick={() => editWallet(wallet.id)}>
                                    <StyledTableCell>{GetLookupValueName('asset', wallet.assetId)}</StyledTableCell>
                                    <StyledTableCell>{wallet.ownerId === Number(process.env.REACT_APP_NEWCENT_CONTACT_ID) ? 'Newcent' : 'Client'}</StyledTableCell>
                                    <StyledTableCell>{wallet.forClientId ? GetClientViewName(clients.find(e => e.id === wallet.forClientId)) : '-'}</StyledTableCell>
                                    <StyledTableCell>{wallet.address}</StyledTableCell>
                                    <StyledTableCell>{wallet.isMultisig ? 'Yes' : 'No'}</StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'left' }}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={totalEntities}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default OwnWalletsPage;
